import { render, staticRenderFns } from "./mercWhiterList.vue?vue&type=template&id=0e271df8&scoped=true&"
import script from "./mercWhiterList.vue?vue&type=script&lang=js&"
export * from "./mercWhiterList.vue?vue&type=script&lang=js&"
import style0 from "./mercWhiterList.vue?vue&type=style&index=0&id=0e271df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e271df8",
  null
  
)

export default component.exports